import type { TypographyVariantsOptions } from "@mui/material/styles";
import type { DesignTokens } from "./types";

export function buildTypography(tokens: DesignTokens): TypographyVariantsOptions {
  const { fontFamily, display, fontSize, lineHeight, fontWeight, letterSpacing } = tokens;
  const ls = letterSpacing ?? {};

  return {
    fontFamily,
    fontWeightRegular: fontWeight.regular,
    fontWeightMedium: fontWeight.medium,
    fontWeightBold: fontWeight.bold,

    // Display styles → MUI headings
    h1: {
      fontSize: display.xl.fontSize,
      lineHeight: display.xl.lineHeight,
      letterSpacing: ls.h1 ?? display.xl.letterSpacing,
      fontWeight: fontWeight.semibold,
    },
    h2: {
      fontSize: display.lg.fontSize,
      lineHeight: display.lg.lineHeight,
      letterSpacing: ls.h2 ?? display.lg.letterSpacing,
      fontWeight: fontWeight.semibold,
    },
    h3: {
      fontSize: display.md.fontSize,
      lineHeight: display.md.lineHeight,
      letterSpacing: ls.h3 ?? display.md.letterSpacing,
      fontWeight: fontWeight.semibold,
    },
    h4: {
      fontSize: display.sm.fontSize,
      lineHeight: display.sm.lineHeight,
      ...(ls.h4 !== undefined && { letterSpacing: ls.h4 }),
      fontWeight: fontWeight.semibold,
    },
    h5: {
      fontSize: display.xs.fontSize,
      lineHeight: display.xs.lineHeight,
      ...(ls.h5 !== undefined && { letterSpacing: ls.h5 }),
      fontWeight: fontWeight.semibold,
    },
    h6: {
      fontSize: fontSize.xl,
      lineHeight: lineHeight.xl,
      ...(ls.h6 !== undefined && { letterSpacing: ls.h6 }),
      fontWeight: fontWeight.semibold,
    },
    subtitle1: {
      fontSize: fontSize.lg,
      lineHeight: lineHeight.lg,
      ...(ls.subtitle1 !== undefined && { letterSpacing: ls.subtitle1 }),
      fontWeight: fontWeight.medium,
    },
    subtitle2: {
      fontSize: fontSize.md,
      lineHeight: lineHeight.md,
      ...(ls.subtitle2 !== undefined && { letterSpacing: ls.subtitle2 }),
      fontWeight: fontWeight.medium,
    },
    body1: {
      fontSize: fontSize.md,
      lineHeight: lineHeight.md,
      ...(ls.body1 !== undefined && { letterSpacing: ls.body1 }),
      fontWeight: fontWeight.regular,
    },
    body2: {
      fontSize: fontSize.sm,
      lineHeight: lineHeight.sm,
      ...(ls.body2 !== undefined && { letterSpacing: ls.body2 }),
      fontWeight: fontWeight.regular,
    },
    caption: {
      fontSize: fontSize.xs,
      lineHeight: lineHeight.xs,
      ...(ls.caption !== undefined && { letterSpacing: ls.caption }),
      fontWeight: fontWeight.regular,
    },
    overline: {
      fontSize: fontSize.xxs,
      lineHeight: lineHeight.xxs,
      fontWeight: fontWeight.medium,
      textTransform: "uppercase",
      letterSpacing: ls.overline ?? "0.08em",
    },
    button: {
      fontSize: fontSize.sm,
      lineHeight: lineHeight.sm,
      fontWeight: fontWeight.semibold,
      textTransform: "none",
      ...(ls.button !== undefined && { letterSpacing: ls.button }),
    },
  };
}

